import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import authHelpers from 'utils/authHelpers';
import Nav from 'ui/Nav';
import AppHeader from 'ui/AppHeader';

export const MicroRoute = ({ children, ...rest }) => {
  const token = authHelpers.getToken();
  
  if (token) {
    const component = React.cloneElement(children);
    
    return (
      <Route {...rest}>
        <AppHeader />
        <Container style={{ flexGrow: 1, paddingBottom: '90px', marginTop: '1rem' }}>
          { component }
        </Container>
        <Nav />
      </Route>
    )
  }
  
  return <Redirect to="/" />
}